// @flow
/**
 * Created by Mike Chung on 2/12/18.
 */
import EBadge from "../../model/ebadge/EBadge";
import * as _ from "lodash";
import React, {Fragment} from "react";
import EBadgeTableRow from "./EBadgeTableRow";
import UnlockEBadgeModal from "../../containers/ebadge/UnlockEBadgeModal";
import FairConfig from "../../model/fair/FairConfig";
import FaSort from 'react-icons/lib/fa/sort';
import FaSortAsc from 'react-icons/lib/fa/sort-asc';
import FaSortDesc from 'react-icons/lib/fa/sort-desc';
import Table from "../util/tables/Table";
import TableHeading from "../util/tables/TableHeading";
import TableRow from "../util/tables/TableRow";
import TableHead from "../util/tables/TableHead";
import TableBody from "../util/tables/TableBody";
import Paginator from "../Paginator";
import type {Location} from "../../types/ReactRouterTypes";
import LockEBadgeModal from "../../containers/ebadge/LockEBadgeModal";
import {Alert} from "reactstrap";
import type {SortDirection, SortOption} from "../../model/ebadge/EBadgeQueryCriteria";
import {Link} from "react-router-dom";
import Idle from 'react-idle';
import {connect} from "react-redux";
import {eBadgeQuerySuccessAction} from "../../actions/ebadge/creators/eBadgeQueryActionCreator";
import type {StoreState} from "../../reducers/combinedReducers";
import type {RoleConfig} from "../../types/utilityTypes";
import {computeUserConfigs} from "../../helpers/utils";
import ValidateEBadgeModal from "../../containers/ebadge/ValidateEBadgeModal";
import InvalidateEBadgeModal from "../../containers/ebadge/InvalidateEBadgeModal";
import "./ebadge-result.css";

type EBadgeQueryResultStateProps = {
    idleTimeout: number
}

type EBadgeQueryResultProps = {
    totalCount: number,
    currentPage: number,
    eBadges: Array<EBadge>,
    fairConfigsByProjectCode: {
        [projectCode: string]: {
            [year: string]: FairConfig
        }
    },
    generatePageLink: (page: number) => Location,
    generateSortLink: (sort: SortOption, direction: SortDirection) => Location,
    currentSort?: SortOption,
    currentSortDirection?: SortDirection,
    resetResult: () => any
} & EBadgeQueryResultStateProps;

function getTargetDirection(props: EBadgeQueryResultProps, sort: SortOption): SortDirection {
    return props.currentSort === sort && props.currentSortDirection === 'asc' ? 'desc' : 'asc'
}

type SortIconProps = {

    currentSort?: SortOption,
    currentSortDirection?: SortDirection,
    sort: SortOption
}

function SortIconInternal(props: SortIconProps) {

    if (props.currentSort === props.sort) {

        if (props.currentSortDirection === 'asc') {
            return <FaSortAsc/>;
        } else {
            return <FaSortDesc/>;
        }
    } else {
        return <FaSort />;
    }
}

function EBadgeQueryResult(props: EBadgeQueryResultProps) {
    return props.totalCount > 0 ? (
        <div>
            <Table>
                <TableHeading>
                    <TableRow>
                        <TableHead>Fair</TableHead>
                        <TableHead><Link
                            to={props.generateSortLink('companyName', getTargetDirection(props, 'companyName'))}>Company Name<SortIconInternal {...props} sort={'companyName'}/></Link></TableHead>
                        <TableHead style={{textAlign: 'center'}}>Salutation</TableHead>
                        <TableHead><Link to={props.generateSortLink('firstName', getTargetDirection(props, 'firstName'))}>First Name<SortIconInternal {...props} sort={'firstName'}/></Link></TableHead>
                        <TableHead><Link to={props.generateSortLink('lastName', getTargetDirection(props, 'lastName'))}>Last Name<SortIconInternal {...props} sort={'lastName'}/></Link></TableHead>
                        <TableHead><Link to={props.generateSortLink('countryCode', getTargetDirection(props, 'countryCode'))}>Country Name<SortIconInternal {...props} sort={'countryCode'}/></Link></TableHead>
                        <TableHead><Link to={props.generateSortLink('email', getTargetDirection(props, 'email'))}>Email<SortIconInternal {...props} sort={'email'}/></Link></TableHead>
                        <TableHead><Link to={props.generateSortLink('registrationCode', getTargetDirection(props, 'registrationCode'))}>Registration Code<SortIconInternal {...props} sort={'registrationCode'}/></Link></TableHead>
                        <TableHead style={{textAlign: 'center'}}><Link to={props.generateSortLink('boothNumber', getTargetDirection(props, 'boothNumber'))}>Booth Number<SortIconInternal {...props} sort={'boothNumber'}/></Link></TableHead>
                        <TableHead><Link to={props.generateSortLink('status', getTargetDirection(props, 'status'))}>Status<SortIconInternal {...props} sort={'status'}/></Link></TableHead>
                        <TableHead style={{textAlign: 'center'}}><Link to={props.generateSortLink('isMarkedDelete', getTargetDirection(props, 'isMarkedDelete'))}>Mark Deleted<SortIconInternal {...props} sort={'isMarkedDelete'}/></Link></TableHead>
                        <TableHead style={{textAlign: 'center'}}><Link to={props.generateSortLink('unlockCount', getTargetDirection(props, 'unlockCount'))}>Unlink Count<SortIconInternal {...props} sort={'unlockCount'}/></Link></TableHead>              
                        <TableHead style={{textAlign: 'center'}}><Link to={props.generateSortLink('isVerifiedData', getTargetDirection(props, 'isVerifiedData'))}>Info Validated<SortIconInternal {...props} sort={'isVerifiedData'}/></Link></TableHead>
                        <TableHead style={{textAlign: 'center'}}><Link to={props.generateSortLink('readableRefId', getTargetDirection(props, 'readableRefId'))}>readableRefId<SortIconInternal {...props} sort={'readableRefId'}/></Link></TableHead>
                        <TableHead style={{textAlign: 'center'}}><Link to={props.generateSortLink('sourceType', getTargetDirection(props, 'sourceType'))}>Source Type<SortIconInternal {...props} sort={'sourceType'}/></Link></TableHead>
                        <TableHead style={{textAlign: 'center'}}><Link to={props.generateSortLink('visitorType', getTargetDirection(props, 'visitorType'))}>Visitor Type<SortIconInternal {...props} sort={'visitorType'}/></Link></TableHead>
                        <TableHead style={{textAlign: 'center'}}><Link to={props.generateSortLink('lastModifyDate', getTargetDirection(props, 'lastModifyDate'))}>Last Modify Date<SortIconInternal {...props} sort={'lastModifyDate'}/></Link></TableHead>
                        <TableHead style={{textAlign: 'center'}} className={"action-column"}>Action</TableHead>
                    </TableRow>
                </TableHeading>
                <TableBody>
                    {
                        _.map(props.eBadges, (e: EBadge, i: number) =>
                            <EBadgeTableRow key={i} eBadge={e} fairName={_.get(props.fairConfigsByProjectCode, `${e.projectCode}.${e.year}.fairCode`)}/>)
                    }
                </TableBody>
            </Table>
            <Paginator currentPage={props.currentPage} pageItem={20} totalCount={props.totalCount} generateLink={props.generatePageLink}/>
            <UnlockEBadgeModal/>
            <LockEBadgeModal/>
            <ValidateEBadgeModal/>
            <InvalidateEBadgeModal/>
        </div>
    ) : (<Alert color={"warning"}>No Record Found!</Alert>);
}



function IdleResult(props: EBadgeQueryResultProps) {
    return (
        <Idle onChange={(idle) => {
            if (idle.idle) {
                props.resetResult();
            }
        }}
              timeout={props.idleTimeout}
              render={({idle}) =>
                  <Fragment>
                      {idle
                          ? null
                          : <EBadgeQueryResult {...props}/>
                      }
                  </Fragment>
              }/>
    );
}

export default connect((state: StoreState): EBadgeQueryResultStateProps => {
    let roleConfig: RoleConfig = computeUserConfigs(state.loginUser.roleIds);
    return {
        idleTimeout: roleConfig.idleTimeout
    };
}, (dispatch) => {
    return {

        resetResult: () => {
            dispatch(eBadgeQuerySuccessAction([], -1));
        }
    };
})(IdleResult);


// WEBPACK FOOTER //
// ./src/components/ebadge/EBadgeQueryResult.js